import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { useGetProducts } from 'src/api/product';
import { useProductListingPath } from 'src/hooks/use-ordering-flow';
import { OrderingV2UiProvider } from 'src/contexts/ordering-v2-ui-context';
import OrderV2CartDrawer from 'src/sections/ordering-v2/order-v2-cart-drawer';
import OrderV2ProductDetailModal from 'src/sections/ordering-v2/order-v2-product-detail-modal';
import OrderV2StoryModal from 'src/sections/ordering-v2/order-v2-story-modal';
import { OV2 } from './ordering-v2-tokens';
import OrderingUtilityBar from './ordering-utility-bar';
import OrderingStoreHeader from './ordering-store-header';

// ----------------------------------------------------------------------

export default function OrderingV2Shell({ children }) {
  const { path } = useProductListingPath({ skipDefaultWhenCheckout: true });
  const { location } = useGetProducts(path);

  return (
    <OrderingV2UiProvider>
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: (theme) => theme.zIndex.appBar,
          bgcolor: 'background.paper',
        }}
      >
        <OrderingUtilityBar />
        <OrderingStoreHeader location={location} />
      </Box>

      <Box
        component="main"
        sx={{
          minHeight: '100vh',
          width: 1,
          bgcolor: OV2.bgLight,
          px: 0,
          pb: 4,
          pt: { xs: 1.5, md: 2 },
        }}
      >
        {children}
      </Box>

      <OrderV2CartDrawer />
      <OrderV2ProductDetailModal />
      <OrderV2StoryModal />
    </OrderingV2UiProvider>
  );
}

OrderingV2Shell.propTypes = {
  children: PropTypes.node,
};

export { OV2 };
